interface PhotoCropHeaderProps {
  title: string
  subtitle?: string
  selectedImagesCount: number
  totalPrintCount: number
}

export function PhotoCropHeader({
  title,
  subtitle,
  selectedImagesCount,
  totalPrintCount
}: PhotoCropHeaderProps) {
  return (
    <div className="text-center mb-6">
      <h1 className="text-xl font-bold">{title}</h1>
      {subtitle && <p className="text-sm opacity-60">{subtitle}</p>}
      <p className="text-sm text-primary">
        {selectedImagesCount} Bilder, {totalPrintCount} Drucke gesamt
      </p>
    </div>
  )
}